import { FormatDateToDMYH } from "helpers/data/dataHandling";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Card,
  Col,
  Dropdown,
  Nav,
  OverlayTrigger,
  Row,
  Tab,
  Tooltip,
} from "react-bootstrap";

import FeedbackTileBg from "assets/images/feedback-tile-bg.png";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getDashboardStores,
  getDashboardWidgetsForStore,
  updateAll,
  updateDrillDown,
  updatePeriod,
  updateStores,
} from "redux/slices/Dashboard";
import { getStores } from "redux/slices/Stores";
import { RootState, store } from "redux/store";
import CustomersChart from "./Widgets/CustomersChart";
import PreferredBrands from "./Widgets/PreferredBrands";
import Statistics, { StatisticsGraph } from "./Widgets/Statistics/Statistics";
import TotalRevenueChart from "./Widgets/TotalRevenueChart";
import { ZMultiSelectDropdown } from "components/ZMultiSelectDropdown";
import classNames from "classnames";
import { DashboardWidget } from "models/dbModels/dashboards/DashboardWidget";
import StatisticsWidget from "./Widgets/Statistics/StatisticsWidget";
import { DashboardDataStats, DashboardDetailedDataStats, DashboardDetailedTimeBasedStats, DashboardTimeBasedData, NegativeSoh, PendingPriceChanges, SalesNegativeGP, StocksCreatedAtStore, TileTypes } from "models/storeModels/DashboardData";
import { TileType } from "models/filters/dashboards/DashboardWidgetsFilterQuery";
import { ZButton } from "components/ZButton";
import { useNavigate } from "react-router";
import { FeedbackLink } from "constants/links";
import { Link } from "react-router-dom";
import { differenceInDays, formatISO } from "date-fns";
import { AgGridReact } from "ag-grid-react";
import { AgGrid } from "components/AgGrid/AgGrid";
import { ZIcon } from "components/ZIcon";
import { ZIconType } from "helpers/utility/iconMap";
import { ZTooltip } from "components/ZTooltip";
import { ReportIds } from "constants/reportIds";

interface tabContentsType {
  id: string;
  title: string;
}

export const DASHBOARD_FETCH_INTERVAL = 1000 * 60 * 5;

export type DashboardType = "business" | "operations";

type DashboardWidgetInfo = DashboardWidget & { storeName: string };

export function NewDashboard({
  dashboardType,
}: {
  dashboardType: DashboardType;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [lastSync, setLastSync] = useState("");
  const stores = useAppSelector((state: RootState) => state.stores);
  const dashboard = useAppSelector((state: RootState) => state.dashboard);
  const currentStoreGroupId = useAppSelector(
    (state: RootState) => state.global.storeGroupId
  );
  const [tabContents, setTabContents] = useState<tabContentsType[]>([]);
  const [widgets, setWidgets] = useState<DashboardWidgetInfo[]>([]);

  // type TimePeriod = {
  //   fromDate: Date;
  //   toDate: Date;
  // }

  // function getEquivalentTimePeriods(data: number[], period: "Month" | "Week" | "Day" | string): { lastPeriod: TimePeriod, currentPeriod: TimePeriod } {
  //   // We want to get the equivalent time periods for the trend data, ie if week is selected as the period and it is currently wednesday, we want to show Mon-Wed of last week compared to this week.
  //   switch(period) {
  //     case "Month":
  //       // If we are on the 15th day of the month for example, we want to get the data for the 1st to 15th of the previous month and the current month
  //       const currentDayOfMonth = new Date().getDate();
  //       const currentMonth = new Date().getMonth();
  //       const currentYear = new Date().getFullYear();
  //       const lastMonth = (currentMonth + 11) % 12;
  //       const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;

  //       const daysInLastMonth = new Date(lastMonthYear, lastMonth + 1, 0).getDate();

  //       const lastMonthFromDate = new Date(lastMonthYear, lastMonth, 1);
  //       const lastMonthToDate = new Date(lastMonthYear, lastMonth, Math.min(currentDayOfMonth, daysInLastMonth));

  //       const currentMonthFromDate = new Date(currentYear, currentMonth, 1);
  //       const currentMonthToDate = new Date(currentYear, currentMonth, currentDayOfMonth);
  //       return {
  //         lastPeriod: { fromDate: lastMonthFromDate, toDate: lastMonthToDate },
  //         currentPeriod: { fromDate: currentMonthFromDate, toDate: currentMonthToDate }
  //       }
  //     case "Week":
  //       const dayOfWeek = new Date().getDay();
  //       const daysToSubtract = (dayOfWeek + 6) % 7;
  //       const currentWeekFromDate = new Date();
  //       currentWeekFromDate.setDate(currentWeekFromDate.getDate() - daysToSubtract);
  //       currentWeekFromDate.setHours(0, 0, 0, 0);
  //       const currentWeekToDate = new Date();

  //       // Get the data for the last week
  //       const lastWeekFromDate = new Date();
  //       lastWeekFromDate.setDate(lastWeekFromDate.getDate() - daysToSubtract - 7);
  //       lastWeekFromDate.setHours(0, 0, 0, 0);

  //       const lastWeekToDate = new Date();
  //       lastWeekToDate.setDate(lastWeekFromDate.getDate() + dayOfWeek);
        
  //       return {
  //         lastPeriod: { fromDate: lastWeekFromDate, toDate: lastWeekToDate },
  //         currentPeriod: { fromDate: currentWeekFromDate, toDate: currentWeekToDate }
  //       }
  //     case "Day":
  //       break;
  //     default:
  //       const year = parseInt(period);
  //       if (isNaN(year)) {
  //         throw new Error("Invalid period");
  //       }

  //       // This is a specific year (the current year)
  //       // We want to get the data for the same period in the previous year
  //       const lastYear = year - 1;
  //       const daysIntoCurrentYear = differenceInDays(new Date(), new Date(year, 0, 1));

  //       const lastYearFromDate = new Date(lastYear, 0, 1);
  //       const lastYearToDate = new Date(lastYear, 0, Math.min(daysIntoCurrentYear, isLeapYear(lastYear) ? 366 : 365));

  //       const currentYearFromDate = new Date(year, 0, 1);
  //       const currentYearToDate = new Date(year, 0, daysIntoCurrentYear);

  //       return {
  //         lastPeriod: { fromDate: lastYearFromDate, toDate: lastYearToDate },
  //         currentPeriod: { fromDate: currentYearFromDate, toDate: currentYearToDate }
  //       }
  //   }
  // }


  // function mapTimeData(data: number[], startDate: Date, endDate: Date) {
  //   const period = tabContents.find((e) => e.id === dashboard.period);

  //   if (period != null) {
  //     const timePeriods = getEquivalentTimePeriods(data, period.id);

  //     const previousFromIndex = differenceInDays(timePeriods.lastPeriod.fromDate, startDate);
  //     const previousToIndex = differenceInDays(timePeriods.lastPeriod.toDate, startDate);
  //     const currentFromIndex = differenceInDays(timePeriods.currentPeriod.fromDate, startDate);
  //     const currentToIndex = differenceInDays(timePeriods.currentPeriod.toDate, startDate);

  //     const previousData = data.slice(previousFromIndex, previousToIndex + 1);
  //     const currentData = data.slice(currentFromIndex, currentToIndex + 1);
  //     console.log("previous data:",   previousData);
  //     console.log("current data:", currentData);
  //   }

  // }

  function setUpTabCategories() {
    const currentYear = new Date().getFullYear();
    setTabContents([
      {
        id: (currentYear - 2).toString(),
        title: (currentYear - 2).toString(),
      },
      {
        id: (currentYear - 1).toString(),
        title: (currentYear - 1).toString(),
      },
      {
        id: currentYear.toString(),
        title: currentYear.toString(),
      },
      {
        id: "Month",
        title: "Month",
      },
      {
        id: "Week",
        title: "Week",
      },
      {
        id: "Day",
        title: "Today",
      },
    ]);
  }

  function refetchDashboardData() {
    dispatch(getDashboardStores());
    fetchTileData();
  }

  function fetchTileData() {
    dispatch(getDashboardWidgetsForStore({ ids: stores.table.map(s => s.id) })).then((res) => {
      const flat = res.stores.flatMap<DashboardWidgetInfo>((s) => s.response.data.map(d => { return { ...d, storeName: s.storeName }}));
      setWidgets(flat);
    });
  }

  const updateStoreList = useCallback(() => {
    dispatch(getStores({ storeGroupIds: [currentStoreGroupId] })).then(
      (res) => {
        if (res.data) {
          dispatch(updateStores({ stores: res.data.map((e: any) => e.id) }));
        }
      }
    );
  }, [currentStoreGroupId]);

  useEffect(() => {
    updateStoreList();
  }, [updateStoreList]);

  //Select stores changes or new data, we update the dashboard, not repull
  useEffect(() => {
    console.log("Selected stores changed, updating dashboard data");
    dispatch(updateAll({}));
    fetchTileData();
  }, [dashboard.selectedStores, dashboard.storeData]);

  useEffect(() => {
    document.title = "Z Freedom - Dashboard";
    setUpTabCategories();
    updateStoreList();
    refetchDashboardData();

    let autoRefresh = setInterval(
      refetchDashboardData,
      DASHBOARD_FETCH_INTERVAL
    );

    return () => {
      clearInterval(autoRefresh);
    };
  }, []);

  function UpdatePeriod(optionValue: any) {
    dispatch(
      updatePeriod({
        period: optionValue,
      })
    );
  }

  useEffect(() => {
    if (dashboard.storeData.stores.length > 0) {
      let date: any = null;
      let latestDate: string = "";
      dashboard.storeData.stores.forEach((data: any) => {
        if (
          data.response &&
          data.response.data &&
          data.response.data.lastUpdated &&
          dashboard.selectedStores.includes(data.storeId)
        ) {
          let lastUpdated = new Date(data.response.data.lastUpdated);
          if (lastUpdated > date) {
            date = lastUpdated;
            latestDate = data.response.data.lastUpdated;
          }
        }
      });
      setLastSync(FormatDateToDMYH(latestDate));
    }
  }, [dashboard.storeData, dashboard.selectedStores]);

  const LastSynced = (
    <div
      className={classNames([
        `last-syn`,
        `ms-auto`,
        {
          invisible: lastSync === "" || lastSync == null,
        },
      ])}
    >
      <span className="me-1">
        <span className="last-syn-title">Last Synced:</span>{" "}
        {lastSync ? lastSync : FormatDateToDMYH(new Date().toISOString())}
      </span>
      {/* Default to current date if no data, this is so the latest sync element will take up the correct spacing */}
      <span style={{ display: "inline-grid" }}>
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip style={{ maxWidth: "150px" }} id="tooltip-bottom">
              Syncs every 15 minutes per store
            </Tooltip>
          }
        >
          <i className="mdi mdi-information dasboard-widget-title float-end d-flex justify-content-end"></i>
        </OverlayTrigger>
      </span>
    </div>
  );

  /** Convert a given date to an index to an array containing data per date starting from startDate.
   * NOTE: If the date is outside of the range of the array, it will be clamped between 0 and arrayLength - 1
   */
  function dateToArrayIndex(date: Date, startDate: Date, arrayLength: number) {
    // use date-fns to get the difference in days between the start date and the date
    // Set both dates to midnight
    date.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    const difference = differenceInDays(date, startDate);
    // return difference >= 0 && difference < arrayLength ? difference : -1;
    return Math.min(Math.max(difference, 0), arrayLength - 1);
  }

  const getDetailedTimeStatsValue = useCallback(<T,>(data: DashboardWidgetInfo, field: keyof T) => {
    const parsedData = JSON.parse(data.data) as DashboardDetailedTimeBasedStats<T>;

    if (parsedData.fromDate == null || parsedData.toDate == null) {
      throw new Error("No date range supplied!");
    }

    const fromDate = new Date(parsedData.fromDate);

    // number of days = length of data[field]. So we can determine the period we need
    const mappedValues = parsedData.data[(convertFieldToCamelCase(field.toString()) as keyof T)] ?? [0];

    // Need to figure out the indexes we want to get the data for based on the selected period
    const period = tabContents.find((e) => e.id === dashboard.period);

    if (period == null) {
      throw new Error("Invalid period");
    }

    switch(period.title) {
      case "Month":
        // From date is start of the current month, to date is today
        const monthFromDate = new Date(new Date().setDate(1));
        const monthToDate = new Date();

        const monthFromIx = dateToArrayIndex(monthFromDate, fromDate, mappedValues.length);
        const monthToIx = dateToArrayIndex(monthToDate, fromDate, mappedValues.length);

        if (monthFromIx === -1 || monthToIx === -1) {
          throw new Error("Given date outside of data range");
        }

        const monthData = mappedValues.slice(monthFromIx, monthToIx + 1);

        return monthData.reduce((acc, val) => acc + val, 0);
      case "Week":
        // From date is the start of the week, to date is today
        const weekFromDate = new Date();
        weekFromDate.setDate(weekFromDate.getDate() - weekFromDate.getDay() + 1);
        weekFromDate.setHours(0, 0, 0, 0);

        const weekToDate = new Date();

        const weekFromIx = dateToArrayIndex(weekFromDate, fromDate, mappedValues.length);
        const weekToIx = dateToArrayIndex(weekToDate, fromDate, mappedValues.length);

        if (weekFromIx === -1 || weekToIx === -1) {
          throw new Error("Given date outside of data range");
        }

        const weekData = mappedValues.slice(weekFromIx, weekToIx + 1);

        return weekData.reduce((acc, val) => acc + val, 0);
      case "Today":
        // From date is today, to date is today

        const todayIx = dateToArrayIndex(new Date(), fromDate, mappedValues.length);
        if (todayIx === -1) {
          throw new Error("Given date outside of data range");
        }

        return mappedValues[todayIx];
      default:
        // Specific year
        const year = parseInt(period.title);
        if (isNaN(year)) {
          throw new Error("Invalid year selected in tab");
        }

        // From date is the start of the year, to date is today if the year is the current year, otherwise the end of the year
        const yearFromDate = new Date(year, 0, 1);
        const yearToDate = year === new Date().getFullYear() ? new Date() : new Date(year, 11, 31);

        const yearFromIx = dateToArrayIndex(yearFromDate, fromDate, mappedValues.length);
        const yearToIx = dateToArrayIndex(yearToDate, fromDate, mappedValues.length);

        if (yearFromIx === -1 || yearToIx === -1) {
          throw new Error("Given date outside of data range");
        }

        const yearData = mappedValues.slice(yearFromIx, yearToIx + 1);

        return yearData.reduce((acc, val) => acc + val, 0);
    }
  }, [dashboard.period, tabContents]);

  const getDetailedDataValue = useCallback(<T,>(data: DashboardWidgetInfo, field: keyof T) => {
    const parsedData = JSON.parse(data.data) as DashboardDetailedDataStats<T>;

    return parsedData.data[(convertFieldToCamelCase(field.toString()) as keyof T)];
  }, []);

  const getAggregatedValue = useCallback(<T,>(name: TileType, type: TileTypes, field: keyof T, aggFunc: (acc: number, val: number) => number = (acc, val) => { return acc + val }, initialReducerValue: number = 0): number | undefined => {
    if (widgets.length === 0) return 0;

    // Only get data for the selected stores
    const data = widgets.filter((w) => w.name === name && w.type === TileTypes[type] && dashboard.selectedStores.includes(w.storeId));
    if (data == null) throw new Error(`No tile could be found for the given for name ${name} and type ${TileTypes[type]}`);

    switch(type) {
      case TileTypes.DashboardDetailedTimeBasedStats:
        const timeAggValue = data.map((d) => getDetailedTimeStatsValue(d, field)).reduce((acc, val) => aggFunc(acc, val), initialReducerValue);
        return isNaN(timeAggValue) ? undefined : timeAggValue;
      case TileTypes.DashboardDetailedDataStats: 
        const dataAggValue = data.map((d) => getDetailedDataValue(d, field)).reduce((acc, val) => aggFunc(acc, val), initialReducerValue);
        return isNaN(dataAggValue) ? undefined : dataAggValue;
      default:
        throw new Error(`TileType ${TileTypes[type]} not implemented yet.`);
    }
  }, [getDetailedDataValue, getDetailedTimeStatsValue, widgets, dashboard.selectedStores]);

  const getValueByStore = useCallback(<T,>(name: TileType, type: TileTypes, fields: (keyof T)[]) => {

    const storeIds = dashboard.selectedStores;

    // Only get data for selected stores
    const data = widgets.filter((w) => w.name === name && w.type === TileTypes[type] && storeIds.includes(w.storeId));
    // if (data == null) throw new Error(`No tile could be found for the given for name ${name} and type ${TileTypes[type]}`);
    
    // Need to still have entries for stores that don't have data so that the grid can display the store name and a 0 value
    const storeData = data.map((d) => d.storeId);
    const missingStores = storeIds.filter((s) => !storeData.includes(s));

    const missingData = missingStores.map((s) => {
      return {
        storeId: s,
        storeName: stores.table.find((store) => store.id === s)?.name,
        ...fields.reduce((acc, field) => {
          acc[convertFieldToCamelCase(field.toString())] = 0;
          return acc;
        }, {} as Record<string, any>)
      };
    });

    switch(type) {
      case TileTypes.DashboardDetailedTimeBasedStats:
        return [...data.map((d) => {
          return {
            storeId: d.storeId,
            storeName: d.storeName,
            ...fields.reduce((acc, field) => {
              acc[convertFieldToCamelCase(field.toString())] = getDetailedTimeStatsValue(d, field);
              return acc;
            }, {} as Record<string, any>)
          };
        }), ...missingData];
      case TileTypes.DashboardDetailedDataStats: 
        return [...data.map((d) => {
          const tileData = {
            storeId: d.storeId,
            storeName: d.storeName,
            ...fields.reduce((acc, field) => {
              acc[convertFieldToCamelCase(field.toString())] = getDetailedDataValue(d, field);
              return acc;
            }, {} as Record<string, any>)
          }

          return tileData;
       }), ...missingData];
      default:
        throw new Error(`TileType ${TileTypes[type]} not implemented yet.`);
    }
  }, [getDetailedDataValue, getDetailedTimeStatsValue, widgets, stores.table, dashboard.selectedStores]);

  function convertFieldToCamelCase(field: string) {
    return field.charAt(0).toLowerCase() + field.slice(1);
  }


  // const getTimeBasedValues = useCallback(<T,>(name: TileType, fields: (keyof T)[]) : TimeBasedGraphData[] => {
  //   if (widgets.length === 0) return [];

  //   const data = widgets.filter((w) => w.name === name);
  //   if (data.length === 0 ) 
  //     return [];


  //   //We're asking for a list of fields, so we'll populate the data for each field (series name)
  //   var returnData: TimeBasedGraphData[] = fields.map((field) => {
  //     return {
  //       seriesValues: [],
  //       seriesName: field.toString(),
  //       data: data.map((d) => {
  //         return {
  //           store: stores.table.find(i => i.id === d.storeId)?.name ?? "Unknown",
  //           storeId: d.storeId,
  //           values: []
  //         } 
  //       })
  //     };
  //   });

  //   var minStartDate: Date = new Date();
  //   var maxEndDate: Date = new Date();
  //   //find the max date range
  //   data.forEach((d) => {
  //     const parsedData = JSON.parse(d.data) as DashboardDetailedTimeBasedStats<T>;

  //     if (parsedData.fromDate == null || parsedData.toDate == null) {
  //       throw new Error("No date range supplied!");
  //     }

  //     const fromDate = new Date(parsedData.fromDate);
  //     const toDate = new Date(parsedData.toDate);

  //     if (minStartDate == null || fromDate < minStartDate) {
  //       minStartDate = fromDate;
  //     }

  //     if (maxEndDate == null || toDate > maxEndDate) {
  //       maxEndDate = toDate;
  //     } 
  //   });

  //   if (minStartDate == null || maxEndDate == null) {
  //     throw new Error("No date range supplied!");
  //   }

  //   //create the series values
  //   for (let d = minStartDate; d <= maxEndDate; d.setDate(d.getDate() + 1)) {
  //     returnData.forEach(x => x.seriesValues.push(new Date(d)));
  //   }

  //   //Fill with null and later we'll populate with the actual values
  //   returnData.forEach((d) => {
  //     d.data.forEach(x => x.values = new Array(d.seriesValues.length).fill(null));
  //   });


  //   fields.forEach((field) => {


  //   //Now to populate the data
  //   data.forEach((d) => {
  //       const parsedData = JSON.parse(d.data) as DashboardDetailedTimeBasedStats<T>;

  //       if (parsedData.fromDate == null || parsedData.toDate == null) {
  //         throw new Error("No date range supplied!");
  //       }

  //       const fromDate = new Date(parsedData.fromDate);

  //       // number of days = length of data[field]. So we can determine the period we need
  //       const mappedValues = parsedData.data[(convertFieldToCamelCase(field.toString()) as keyof T)] ?? [0];


  //       var match = returnData.find(x => x.seriesName === field.toString())?.data.find((e) => e.storeId === d.storeId);

  //       if (match == null) {
  //         throw new Error("Data mismatch");
  //       }

  //       // Need to figure out the indexes we want to start at and then copy the mappedValues into it
  //       const fromIx = dateToArrayIndex(fromDate, minStartDate, match.values.length);
        
  //       match.values.splice(fromIx, mappedValues.length, ...mappedValues);

  //     });
  //   });

  //   return returnData;

  // }, [widgets]);

  const BusinessDashboardLayout = useMemo<JSX.Element>(() => {
    return (
      <>
        <Row className="dashboard-r2 row-gap-2">
          <Col xl={8} className="pe-0 pe-lg-2">
            <Statistics />
          </Col>
          <Col xl={4} className="pe-0">
            <PreferredBrands />
          </Col>
        </Row>

        <Row className="dashboard-r3 d-flex" style={{ minHeight: "600px" }}>
          <Col xl={8} className="pe-0 pb-2">
            <TotalRevenueChart />
          </Col>
          <Col xl={4} className="me-sm-0 flex-grow pe-0 pb-2">
            <CustomersChart />
          </Col>
        </Row>
      </>
    );
  }, []);

  const OperationsDashboardLayout = useMemo<JSX.Element>(() => {

    const getNavigateStartDate = (period: string) => {
      switch(period) {
        case "Month":
          return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        case "Week":
          const dayOfWeek = new Date().getDay();
          const daysToSubtract = (dayOfWeek + 6) % 7;
          const weekFromDate = new Date();
          weekFromDate.setDate(weekFromDate.getDate() - daysToSubtract);
          weekFromDate.setHours(0, 0, 0, 0);
          return weekFromDate;
        case "Day":
          return new Date();
        default:
          return new Date(parseInt(period), 0, 1);
      }
    }

    const getNavigateEndDate = (period: string) => {
      // If we've selected this year, the end date will be today, for all other years the end date will be 31st of December
      if (parseInt(period) === new Date().getFullYear()) {
        return new Date();
      } else {
        switch(period) {
          case "Month":
          case "Week":
          case "Day":
            return new Date();
          default:
            return new Date(parseInt(period), 11, 31);
        }
      }
    }

    type DrillDownUrl = "/ReportViewer/" | "/stocks-created-at-store/" | "/pending-price-changes/";

    const getNavigateUrl = (storeId: number, addDates: boolean, url: DrillDownUrl, reportId?: number) => {
      let navigateUrl = "/app" + url + (reportId ? reportId : "") + "?storeId=" + storeId + "&generate=true";
      if (addDates) {
        const period = tabContents.find((e) => e.id === dashboard.period);
        if (period != null) {
          const startDate = getNavigateStartDate(period.title);
          const endDate = getNavigateEndDate(period.title);
          navigateUrl += "&startDate=" + formatISO(startDate, { representation: "date" }) + "&endDate=" + formatISO(endDate, { representation: "date" });
        }
      }

      return navigateUrl;
    }

    const calculateNegativeSalesGP = () => {
      const totalSalesGP = getAggregatedValue<typeof SalesNegativeGP>(TileType.SalesNegativeGP, TileTypes.DashboardDetailedTimeBasedStats, "TotalSalesGP");
      const totalRounding = getAggregatedValue<typeof SalesNegativeGP>(TileType.SalesNegativeGP, TileTypes.DashboardDetailedTimeBasedStats, "TotalRounding");
      if (totalSalesGP == null || totalRounding == null) return undefined;
      return totalSalesGP + totalRounding;
    }

    const RequestFeedback = 
        <div
          className="d-flex flex-column align-items-center justify-content-center gap-2 h-100 w-100"
        >
          <p className="mb-0 text-center">Have an idea of what should go here?</p>
          <ZButton variant="light">
            <Link to={FeedbackLink} target="_blank">Submit your idea</Link>
          </ZButton>
        </div>

    const SettingHelpTooltip = ({ text }: { text: string }) =>
    <ZTooltip
      text="To enable setting go to Z Office > Settings > Store Settings > Tick Allow Review of Price Changes"
      className="d-inline-flex" // Forces the tooltip container to be inline-flex
    >
      <span style={{ fontWeight: "bold", wordBreak: "break-all", cursor: "pointer" }}>
        {text}
      </span>
    </ZTooltip>

    return (
      <>
        <Row className="dashboard-r2 row-gap-2">
          <Col lg={6} xl={3} className="pe-0">
            <StatisticsWidget
              icon="mdi mdi-tag-minus-outline"
              title="Negative SOH Stocks"
              isMoney={false}
              stats={getAggregatedValue<typeof NegativeSoh>(TileType.NegativeSoh, TileTypes.DashboardDetailedDataStats, "Count")}
              rightPanel={[
                {
                  name: "Value",
                  value: getAggregatedValue<typeof NegativeSoh>(TileType.NegativeSoh, TileTypes.DashboardDetailedDataStats, "Value")?.formatAsPrice(true, true) ?? "",
                },
              ]}
              separatorColour={"rgba(109, 117, 125, 0.2)"}
              footerComponent={
                <>
                  <ZIcon icon={ZIconType.Information} size="12px" />
                  <p className="mb-0 text-muted"style={{ fontSize: "12px" }}>
                    Based on data as of now, date filter is not applicable
                  </p>
                </>
              }
              drilldownKeyword="NegativeSOHStocks"
              enableDrillDown
              drilldownSize="lg"
              drillDownClicked={() => true}
            >
              <AgGrid
                columnDefs={[
                  { headerName: "Store", field: "storeName", cellRendererSelector: (params: any) => {
                    const storeIsConnected = stores.table.find((s) => s.id === params.data.storeId)?.connected ?? false;
                    const href = storeIsConnected ? getNavigateUrl(params.data.storeId ?? 0, false, "/ReportViewer/", ReportIds.Negative_SOH) : undefined;
                    return {
                      component: storeIsConnected ? "linkCellRenderer" : "baseCellRenderer",
                      params: {
                        href: href, 
                        decorators: [ { decorator: <ZTooltip text={storeIsConnected ? "Online" : "Offline"}><ZIcon icon={storeIsConnected ? ZIconType.Connected : ZIconType.Disconnected} variant={storeIsConnected ? "success" : "danger"} /></ZTooltip>, position: "end", containerClassName: "ms-auto" } ],
                      },
                    }
                  }, sortable: true, initialSort: "asc" },
                  { headerName: "Total Stock Count", field: "count", sortable: true, headerClass: "ag-right-aligned-header", cellRendererParams: { align: "right" } },
                  { headerName: "Total Stock Value", field: "value", sortable: true, cellRenderer: "priceCellRenderer", headerClass: "ag-right-aligned-header", cellRendererParams: { align: "right" }},
                ]}
                loading={false}
                rowData={getValueByStore<typeof NegativeSoh>(TileType.NegativeSoh, TileTypes.DashboardDetailedDataStats, ["Count", "Value"])}
              />
            </StatisticsWidget>
          </Col>
          <Col lg={6} xl={3} className="pe-0">
            <StatisticsWidget
              icon="mdi mdi-tag-plus-outline"
              title="Stocks Created At Store"
              isMoney={false}
              stats={getAggregatedValue<typeof StocksCreatedAtStore>(TileType.StocksCreatedAtStore, TileTypes.DashboardDetailedTimeBasedStats, "Count")}
              drilldownKeyword="StocksCreatedAtStore"
              enableDrillDown
              drilldownSize="lg"
              drillDownClicked={() => true}
              footerComponent={
                <>
                  <ZIcon icon={ZIconType.Information} size="12px" />
                  <span className="text-muted" style={{ fontSize: "12px" }}>
                    Based off stock created by users at the{" "}
                        <ZTooltip
                          text=" Excludes stock created by Freedom or Product Updates"
                          className="d-inline-flex" // Forces the tooltip container to be inline-flex
                        >
                          <span style={{ fontWeight: "bold", wordBreak: "break-all", cursor: "pointer" }}>
                            store
                          </span>
                        </ZTooltip>{" "}
                    </span>
                </>
              }
            >
              <AgGrid
                loading={false}
                columnDefs={[
                  { headerName: "Store", field: "storeName", cellRendererSelector: (params) => {
                    const storeIsConnected = stores.table.find((s) => s.id === params.data.storeId)?.connected ?? false;
                    const href = storeIsConnected ? getNavigateUrl(params.data.storeId ?? 0, true, "/stocks-created-at-store/") : undefined;
                    return {
                      component: storeIsConnected ? "linkCellRenderer" : "baseCellRenderer",
                      params: {
                        href: href, 
                        decorators: [ { decorator: <ZTooltip text={storeIsConnected ? "Online" : "Offline"}><ZIcon icon={storeIsConnected ? ZIconType.Connected : ZIconType.Disconnected} variant={storeIsConnected ? "success" : "danger"} /></ZTooltip>, position: "end", containerClassName: "ms-auto" }],
                      },
                    }
                    
                  }, sortable: true, initialSort: "asc" },
                  { headerName: "Total Stock Created", field: "count", sortable: true, headerClass: "ag-right-aligned-header", cellRendererParams: { align: "right" } },
                ]}
                rowData={getValueByStore<typeof StocksCreatedAtStore>(TileType.StocksCreatedAtStore, TileTypes.DashboardDetailedTimeBasedStats, ["Count"])}
              />
            </StatisticsWidget>
          </Col>
          <Col lg={6} xl={3} className="pe-0">
            <StatisticsWidget
              icon="mdi mdi-trending-down"
              title="Negative GP$ Sales"
              isMoney={false}
              stats={getAggregatedValue<typeof SalesNegativeGP>(TileType.SalesNegativeGP, TileTypes.DashboardDetailedTimeBasedStats, "Count")}
              rightPanel={[
                {
                  name: "Value",
                  value: calculateNegativeSalesGP()?.formatAsPrice(true, true) ?? "",
                },
              ]}
              separatorColour={"rgba(109, 117, 125, 0.2)"}
              drilldownKeyword="NegativeGPSales"
              enableDrillDown
              drilldownSize="lg"
              drillDownClicked={() => true}
            >
              <AgGrid
                loading={false}
                columnDefs={[
                  { headerName: "Store", field: "storeName", cellRendererSelector: (params: any) => {
                    const storeIsConnected = stores.table.find((s) => s.id === params.data.storeId)?.connected ?? false;
                    const href = storeIsConnected ? getNavigateUrl(params.data.storeId ?? 0, true, "/ReportViewer/", ReportIds.Negative_GP_Sales) : undefined;
                    return {
                      component: storeIsConnected ? "linkCellRenderer" : "baseCellRenderer",
                      params: {
                        href: href, 
                        decorators: [ { decorator: <ZTooltip text={storeIsConnected ? "Online" : "Offline"}><ZIcon icon={storeIsConnected ? ZIconType.Connected : ZIconType.Disconnected} variant={storeIsConnected ? "success" : "danger"} /></ZTooltip>, position: "end", containerClassName: "ms-auto" }],
                      },
                    }
                  }, sortable: true, initialSort: "asc" },
                  { headerName: "Total Item Count", field: "count", sortable: true, headerClass: "ag-right-aligned-header", cellRendererParams: { align: "right" } },
                  { headerName: "Total Item Value", valueGetter: (params) => {
                    return params.data.totalSalesGP + params.data.totalRounding;
                  }, sortable: true, cellRenderer: "priceCellRenderer", headerClass: "ag-right-aligned-header", cellRendererParams: { align: "right" }},
                ]}
                rowData={getValueByStore<typeof SalesNegativeGP>(TileType.SalesNegativeGP, TileTypes.DashboardDetailedTimeBasedStats, ["Count", "TotalSalesGP", "TotalRounding"])}
              />
            </StatisticsWidget>
          </Col>
          <Col lg={6} xl={3} className="pe-0">
            <StatisticsWidget
              icon="mdi mdi-cash-clock"
              title="Pending Price Changes"
              isMoney={false}
              stats={getAggregatedValue<typeof PendingPriceChanges>(TileType.PendingPriceChanges, TileTypes.DashboardDetailedDataStats, "Count")}
              footerComponent={
                <>
                  <ZIcon icon={ZIconType.Information} size="12px" />
                  <span className="text-muted" style={{ fontSize: "12px" }}>
                    {getAggregatedValue<typeof PendingPriceChanges>(
                      TileType.PendingPriceChanges,
                      TileTypes.DashboardDetailedDataStats,
                      "Enabled",
                      (acc, val) => acc | val,
                      0
                    ) ? (
                      <>
                        Based on{" "}<SettingHelpTooltip text="setting enabled" />{" "}
                        at stores, date filter is not applicable
                      </>
                    ) : (
                      
                      <>
                        No results - Review of Price Changes{" "}
                        <SettingHelpTooltip text="setting not enabled" />{" "}
                        at any store
                      </>
                    )}
                  </span>
                </>
              }
              drilldownKeyword="PendingPriceChanges"
              enableDrillDown
              drilldownSize="lg"
              drillDownClicked={() => true}
            >
              <AgGrid
                loading={false}
                columnDefs={[
                  { headerName: "Store", field: "storeName", cellRendererSelector: (params: any) => {
                    const storeIsConnected = stores.table.find((s) => s.id === params.data.storeId)?.connected ?? false;
                    const href = storeIsConnected ? getNavigateUrl(params.data.storeId ?? 0, false, "/pending-price-changes/") : undefined;
                    return {
                      component: storeIsConnected ? "linkCellRenderer" : "baseCellRenderer",
                      params: {
                        href: href, 
                        decorators: [ { decorator: <ZTooltip text={storeIsConnected ? "Online" : "Offline"}><ZIcon icon={storeIsConnected ? ZIconType.Connected : ZIconType.Disconnected} variant={storeIsConnected ? "success" : "danger"} /></ZTooltip>, position: "end", containerClassName: "ms-auto" }],
                      },
                    }
                  }, sortable: true, initialSort: "asc"  },
                  { headerName: "Total Price Changes", field: "count", sortable: true, headerClass: "ag-right-aligned-header", cellRendererParams: { align: "right" } },
                  { headerName: "Setting Enabled", field: "enabled", headerClass: "ag-center-aligned-header", cellStyle: { textAlign: "center" }, cellRenderer: (params: any) => <ZIcon icon={params.value ? ZIconType.Check : ZIconType.Close} variant={params.value ? "success" : "danger" } />},
                ]}
                rowData={getValueByStore<typeof PendingPriceChanges>(TileType.PendingPriceChanges, TileTypes.DashboardDetailedDataStats, ["Enabled", "Count"])}
              />
            </StatisticsWidget>
          </Col>
        </Row>
        <Row className="dashboard-r3 row-gap-2 pb-2">
          <Col sm={12} lg={8} className="pe-0">
            <Card className="mb-0" style={{ height: 400 }}>
                <Card.Body className="d-inline-flex h-100 align-items-center">
                  <img
                  src={FeedbackTileBg}
                  alt="Feedback"
                  className="d-none d-sm-block"
                  style={{ height: "100%", width: "auto", maxWidth: "60%", aspectRatio: 1, objectFit: "contain" }}
                  />
                  {RequestFeedback}
                </Card.Body>
            </Card>
          </Col>
          <Col sm={12} lg={4} className="d-flex flex-column row-gap-2">
            <Row className="flex-grow">
              <Col sm={12} className="pe-0">
                <Card className="h-100 mb-0" style={{ minHeight: 180 }}>
                  <Card.Body >
                    {RequestFeedback}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="flex-grow">
              <Col sm={12} className="pe-0">
                <Card className="h-100 mb-0" style={{ minHeight: 180 }}>
                  <Card.Body>
                    {RequestFeedback}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    );
  }, [getAggregatedValue]);

  const getDashboardTitle = (dashboardType: DashboardType) => {
    switch (dashboardType) {
      case "business":
        return "Business Dashboard";
      case "operations":
        return "Operations Dashboard";
    }
  };

  return (
    <>
      <Row className="dashboard-r1">
        <Col xxl={3} sm={5} xs={12} className="pe-2">
          <h1 className="page-title mb-0">
            {getDashboardTitle(dashboardType)}
          </h1>
        </Col>
        <Col
          xxl={false}
          sm={7}
          xs={12}
          className={classNames(
            "justify-content-end flex-grow d-inline-flex d-xxl-none pe-0 mb-1",
            { "d-none": lastSync === "" || lastSync == null }
          )}
        >
          {LastSynced}
        </Col>
        <Col xxl={9} lg={12} xs={12} className="pe-0 mb-1 mb-sm-0">
          <div className="page-title-box dashboard-dropdown-menus gap-2">
            <div
              className="mb-1 dropdown-menu-buttons gap-1 align-items-center"
              style={{ flexGrow: 2 }}
            >
            <div className="d-xxl-inline-flex d-none" style={{ flexGrow: 1 }}>
              {LastSynced}
            </div>
              <ZMultiSelectDropdown
                values={stores.table.filter((s) =>
                  dashboard.selectedStores.includes(s.id)
                )}
                options={stores.table}
                display={(s) => s.name}
                disabled={(s) => !s.connected}
                containerClassName="d-flex flex-grow align-items-center"
                containerStyle={{
                  maxWidth: "300px"
                }}
                hasSearch
                hasAllOption
                minMenuWidthPx={300}
                id="dasboard-stores-dropdown"
                value={(s) => s.id}
                onSelectionChange={(stores) =>
                  dispatch(updateStores({ stores: stores.map((s) => s.id) }))
                }
                placeholder="Select stores"
                maxShownSelectedOptions={3}
              />
              <Dropdown className="dasboard-year-dropdown">
                <Dropdown.Toggle
                  id="dropdown-basic2"
                  variant="primary"
                  className="cta-button"
                  style={{
                    borderRadius: "5px",
                    fontSize: `var(--bs-nav-link-font-size)`,
                  }}
                >
                  {dashboard.period}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ width: "80px" }}>
                  {tabContents.map((e, index) => (
                    <Dropdown.Item
                      key={e.id}
                      id={e.id.toString()}
                      active={dashboard.period === e.id}
                      onClick={() => UpdatePeriod(e.id)}
                    >
                      {e.title}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <div className="dashboard-time-tab">
                <Tab.Container defaultActiveKey={new Date().getFullYear()}>
                  <Nav variant="pills" justify className="bg-nav-pills">
                    {tabContents.map((tab, index) => {
                      return (
                        <Nav.Item
                          key={index}
                          onClick={() => UpdatePeriod(tab.id)}
                        >
                          <Nav.Link eventKey={tab.title}>
                            <span className="d-md-block">{tab.title}</span>
                          </Nav.Link>
                        </Nav.Item>
                      );
                    })}
                  </Nav>
                </Tab.Container>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {dashboardType === "business" && BusinessDashboardLayout}
      {dashboardType === "operations" && OperationsDashboardLayout}
    </>
  );
}
